<template>
  <div class="page-content offer-page">
    <vue-headful
      title="Сдать картину на аукцион ARTinvestment.RU | Продать живопись и графику онлайн выгодно"
      description="Примем вашу картину на аукцион ARTinvestment.RU. Крупнейший и старейший аукционный дом. Еженедельные онлайн-торги. Бесплатная предаукционная оценка."
      :keywords="keywords"
    />
    <div class="offer-page__breadcrumbs">
      <breadcrumbs :breadcrumbs="breadcrumbs" />
    </div>

    <template v-if="!isSent">
      <h1 class="offer-page__title">
        Сдать картину на&nbsp;аукцион ARTinvestment.RU&nbsp;&mdash; продать
        живопись и&nbsp;графику онлайн выгодно!
      </h1>

      <ul class="offer-page__advantages hidden-xs">
        <li class="advantages-card">
          <img
            class="advantages-card__img"
            src="/assets/icons/icon-1.svg"
            alt=""
          />
          <div class="advantages-card__inner">
            <p class="advantages-card__title">
              Работаем <br />
              с&nbsp;2007&nbsp;года
            </p>
            <p class="advantages-card__text">
              АртИнвестмент&nbsp;&mdash; крупнейший и&nbsp;старейший портал
              о&nbsp;русском искусстве в&nbsp;России.
            </p>
          </div>
        </li>
        <li class="advantages-card">
          <img
            class="advantages-card__img"
            src="/assets/icons/icon-2.svg"
            alt=""
          />
          <div class="advantages-card__inner">
            <p class="advantages-card__title">
              7000+ <br />
              проданных лотов
            </p>
            <p class="advantages-card__text">
              Каждую неделю тысячи коллекционеров со&nbsp;всей России участвуют
              в&nbsp;наших торгах.
            </p>
          </div>
        </li>
        <li class="advantages-card">
          <img
            class="advantages-card__img"
            src="/assets/icons/icon-3.svg"
            alt=""
          />
          <div class="advantages-card__inner">
            <p class="advantages-card__title">Официальное <br />оформление</p>
            <p class="advantages-card__text">
              Заключаем официальный договор для прозрачности и&nbsp;безопасности
              сделки.
            </p>
          </div>
        </li>
      </ul>

      <div class="offer-page__advantages visible-xs">
        <hooper
          class=""
          group="group1"
          ref="carouselMin"
          :itemsToShow="1"
          style="--hooper-slide-spacing: 20px"
          :center-mode="false"
        >
          <slide>
            <div class="advantages-card">
              <img
                class="advantages-card__img"
                src="/assets/icons/icon-1.svg"
                alt=""
              />
              <div class="advantages-card__inner">
                <p class="advantages-card__title">
                  Работаем <br />
                  с&nbsp;2007&nbsp;года
                </p>
                <p class="advantages-card__text">
                  АртИнвестмент&nbsp;&mdash; крупнейший и&nbsp;старейший портал
                  о&nbsp;русском искусстве в&nbsp;России.
                </p>
              </div>
            </div>
          </slide>
          <slide>
            <div class="advantages-card">
              <img
                class="advantages-card__img"
                src="/assets/icons/icon-2.svg"
                alt=""
              />
              <div class="advantages-card__inner">
                <p class="advantages-card__title">
                  7000+ <br />
                  проданных лотов
                </p>
                <p class="advantages-card__text">
                  Каждую неделю тысячи коллекционеров со&nbsp;всей России
                  участвуют в&nbsp;наших торгах.
                </p>
              </div>
            </div>
          </slide>
          <slide>
            <div class="advantages-card">
              <img
                class="advantages-card__img"
                src="/assets/icons/icon-3.svg"
                alt=""
              />
              <div class="advantages-card__inner">
                <p class="advantages-card__title">
                  Официальное <br />оформление
                </p>
                <p class="advantages-card__text">
                  Заключаем официальный договор для прозрачности
                  и&nbsp;безопасности сделки.
                </p>
              </div>
            </div>
          </slide>
          <pagination slot="hooper-addons"></pagination>
        </hooper>
      </div>

      <p class="offer-page__lead">Заполните, пожалуйста, форму</p>

      <form class="offer-page__form" @submit.prevent="handleSubmit">
        <div class="offer-page__form-wrap">
          <div class="offer-page__form-group">
            <form-control
              v-model="form.femail"
              placeholder="E-mail"
              :errorMessage="validation.firstError('form.femail')"
            />
            <form-control
              v-model="form.fname"
              placeholder="Имя"
              :errorMessage="validation.firstError('form.fname')"
            />
            <form-control
              v-model="form.ftel"
              type="tel"
              placeholder="Телефон"
              :errorMessage="validation.firstError('form.ftel')"
            />
            <div>
              <form-control
                class="visually-hidden"
                v-model="form.fpainter"
                type="text"
                placeholder="Айвазовский Иван Константинович"
                :errorMessage="validation.firstError('form.fpainter')"
              />
              <button
                class="offer-page__artist-btn"
                type="button"
                v-on:click="showArtistModal"
              >
                <span v-if="!form.fpainter">Укажите фамилию художника</span>
                <span v-else>{{ form.fpainter }}</span>
              </button>
              <span
                class="offer-page__form-error"
                v-if="validation.firstError('form.fpainter')"
                >{{ validation.firstError("form.fpainter") }}</span
              >
            </div>
          </div>
          <div class="offer-page__form-group">
            <form-control
              v-model="form.fsize"
              placeholder="Длина и ширина (высота для скульптур)"
              :errorMessage="validation.firstError('form.fsize')"
            />
            <form-control
              v-model="form.fprice"
              placeholder="Желаемая стоимость"
              :errorMessage="validation.firstError('form.fprice')"
            />
            <form-control
              v-model="form.ftechnique"
              placeholder="Техника работы"
              :errorMessage="validation.firstError('form.ftechnique')"
            />
            <form-control
              v-model="form.ftextarea"
              placeholder="Комментарий"
              :errorMessage="validation.firstError('form.ftextarea')"
            />
          </div>
        </div>
        <div class="offer-page__form-wrap">
          <div class="offer-page__form-group">
            <p class="offer-page__form-title">
              Что вы хотите сделать с работой?
            </p>
            <ul class="offer-page__form-list">
              <li>
                <form-checkbox
                  :value="form.actionType.includes('auction')"
                  curValue="auction"
                  text="Выставить на аукцион"
                  @input="toggleActionType('auction', $event)"
                  :errorMessage="validation.firstError('form.actionType')"
                />
              </li>
              <li>
                <form-checkbox
                  :value="form.actionType.includes('sell')"
                  curValue="sell"
                  text="Продать вне аукциона"
                  @input="toggleActionType('sell', $event)"
                  :errorMessage="validation.firstError('form.actionType')"
                />
              </li>
              <li>
                <form-checkbox
                  :value="form.actionType.includes('buyout')"
                  curValue="buyout"
                  text="Нужен выкуп"
                  @input="toggleActionType('buyout', $event)"
                  :errorMessage="validation.firstError('form.actionType')"
                />
              </li>
            </ul>
          </div>
          <div class="offer-page__form-group">
            <p class="offer-page__form-title">Наличие экспертизы</p>
            <ul class="offer-page__form-list">
              <li>
                <form-radio
                  v-model="form.expertise"
                  radioValue="yes"
                  text="Да"
                  name="expertise"
                  :checked="form.expertise === 'yes'"
                  :errorMessage="validation.firstError('form.expertise')"
                />
              </li>
              <li>
                <form-radio
                  v-model="form.expertise"
                  radioValue="no"
                  text="Нет"
                  name="expertise"
                  :checked="form.expertise === 'no'"
                  :errorMessage="validation.firstError('form.expertise')"
                />
              </li>
            </ul>
          </div>
        </div>
        <div class="form-uploader">
          <UploadImages
            upload-msg="Перетащите файлы сюда, чтобы загрузить"
            @change="handleImages"
            @changed="handleImages"
          />
          <span class="offer-page__form-error" v-if="isFilesEmpty"
            >Не заполнено поле</span
          >
        </div>
        <base-button
          default
          size="large"
          title="Отправить"
          :disabled="isSave || !isUploadFiles"
          @click.native="handleSubmit"
        />
        <p class="offer-page__note">
          Нажимая на кнопку «Отправить», Вы соглашаетесь с политикой обработки
          персональных данных
        </p>
      </form>

      <hr class="offer-page__line" />

      <p class="offer-page__lead">Или свяжитесь с нами</p>

      <div class="offer-page__contacts">
        <p class="offer-page__contacts-item offer-page__contacts-item--email">
          <a :href="`mailto:${contacts.email_primary}`">{{
            contacts.email_primary
          }}</a>
        </p>
        <p class="offer-page__contacts-item offer-page__contacts-item--phone">
          <span class="sidebar-detail__phones">
            <a
              :href="`tel:${contacts.phone_secondary}`"
              v-html="phoneFormatted(contacts.phone_secondary)"
            ></a>
            <a
              :href="`tel:${contacts.phone_primary}`"
              v-html="phoneFormatted(contacts.phone_primary)"
            ></a>
          </span>
        </p>
      </div>

      <hr class="offer-page__line" />

      <p class="offer-page__lead">
        Для принятия решения об участии вещи в аукционе AI нам понадобятся:
      </p>
      <ol class="offer-page__list">
        <li>
          <div>
            <b>Фотографии лицевой и&nbsp;оборотной стороны, отдельно</b
            >&nbsp;&mdash; подписи, надписей и&nbsp;пр., нормального качества
            (нормальной резкости, освещенности и&nbsp;цветопередачи,
            с&nbsp;размерами файлов не&nbsp;менее 300&ndash;400&nbsp;Кбайт).
          </div>
        </li>
        <li>
          <div>
            <p><b>Описание произведения:</b></p>
            <ul>
              <li>
                фамилия, имя, отчество автора, год его рождения / годы жизни;
              </li>
              <li>название работы;</li>
              <li>год создания работы;</li>
              <li>материал;</li>
              <li>техника;</li>
              <li>размер работы;</li>
              <li>тираж и номер экземпляра (для тиражной графики);</li>
              <li>наличие или отсутствие оформления (рама, паспарту и пр.).</li>
            </ul>
          </div>
        </li>
        <li>
          <div>
            <p>
              <b>Провенанс</b> – сведения об истории бытования произведения:
            </p>
            <ul>
              <li>
                принадлежность к частным собраниям, участие в выставках,
                аукционах, упоминания в публикациях.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <div>
            <b>Экспертиза</b> и другие письменные подтверждения подлинности от
            профильных экспертов. Возможны письменные подтверждения подлинности
            от самих авторов или наследников художников.
          </div>
        </li>
        <li>
          <div>
            <b>Резервная цена продавца.</b>
          </div>
        </li>
      </ol>
      <div class="offer-page__attention">
        <div>
          <p>
            <b>Решение об участии работы в аукционе</b> принимается и сообщается
            владельцу работы в течение 7 рабочих дней после получения от него
            всей необходимой информации. Отрицательные решения не
            комментируются.
          </p>
          <p>
            Работы, сопровождаемые в базе аукционных результатов
            ARTinvestment.RU красными индикаторами инвестиционного риска, не
            рассматриваются.
          </p>
          <p>
            На время проведения аукциона (5 дней) предмет и (при наличии)
            документы, подтверждающие подлинность, должны быть предоставлены на
            ответственное хранение в офис ARTinvestment.RU. Если соблюсти это
            условие невозможно, предмет на аукцион AI не принимается.
          </p>
        </div>
      </div>
    </template>
    <template v-else>
      <h1 class="offer-page__title">Благодарим за Ваш запрос!</h1>
    </template>

    <artist-modal @artist-selected="setArtist" />
  </div>
</template>

<script>
import FormControl from "@/components/form/FormControl";
import BaseButton from "@/components/buttons/BaseButton";
import Breadcrumbs from "@/components/base/Breadcrumbs";
import SimpleVueValidator from "simple-vue-validator";
import UploadImages from "vue-upload-drop-images";
import { mapGetters, mapState } from "vuex";
import Vue from "vue";
import vueHeadful from "vue-headful";
import { Hooper, Slide, Pagination } from "hooper";
import "hooper/dist/hooper.css";

Vue.component("vue-headful", vueHeadful);

import axios from "@/requests";
import ArtistModal from "@/components/modals/ArtistModal.vue";
import FormCheckbox from "@/components/form/FormCheckbox.vue";
import FormRadio from "@/components/form/FormRadio.vue";

const Validator = SimpleVueValidator.Validator;

export default {
  name: "OfferPage",
  mixins: [SimpleVueValidator.mixin],
  validators: {
    "form.fsize": function (value) {
      return Validator.value(value).required("Не заполнено поле");
    },
    "form.ftechnique": function (value) {
      return Validator.value(value).required("Не заполнено поле");
    },
    "form.femail": function (value) {
      return Validator.value(value)
        .required("Не заполнено поле")
        .email("Некорректный адрес");
    },
    "form.fname": function (value) {
      return Validator.value(value).required("Не заполнено поле");
    },
    "form.fpainter": function (value) {
      return Validator.value(value).required("Не заполнено поле");
    },
    "form.actionType": function (value) {
      return Validator.value(value)
        .required("Выберите хотя бы один вариант")
        .custom(() => {
          if (value.length === 0) {
            return "Выберите хотя бы один вариант";
          }
        });
    },
    "form.expertise": function (value) {
      return Validator.value(value).required("Выберите один вариант");
    },
  },
  components: {
    FormRadio,
    FormCheckbox,
    ArtistModal,
    BaseButton,
    Breadcrumbs,
    FormControl,
    UploadImages,
    Hooper,
    Slide,
    Pagination,
  },
  data() {
    return {
      breadcrumbs: [
        {
          link: "/",
          title: "Главная",
        },
        {
          title: "Предложить работу на аукцион AI",
        },
      ],
      isSent: false,
      isFilesEmpty: false,
      files: [],
      filesList: {},
      uri: "https://artinvestment.ru",
      isSave: false,
      form: {
        fform: "https://auction.artinvestment.ru/offer",
        femail: "",
        ftel: "",
        ftextarea: "",
        fsize: "",
        fprice: "",
        ftechnique: "",
        fname: "",
        fpainter: "",
        files: [],
        ftype: "sellw",
        actionType: [],
        expertise: "",
      },
      keywords:
        "сдать картину на аукцион, продать картину аукцион россия, аукцион живописи, сдать графику на аукцион, предаукционная оценка бесплатно, продать живопись выгодно, аукцион произведений искусства, ARTinvestment аукцион, еженедельные торги картин, комиссионная продажа картин россия, онлайн аукцион картин, продать картину онлайн, сдать картину онлайн аукцион",
    };
  },
  computed: {
    ...mapState(["base"]),
    ...mapGetters({
      contacts: "base/CONTACTS",
    }),
    isUploadFiles() {
      let is_upload = true;
      if (Object.keys(this.filesList).length) {
        Object.keys(this.filesList).forEach((index) => {
          if (this.filesList[index] === null) is_upload = false;
        });
      }
      return is_upload;
    },
  },
  methods: {
    setArtist(artistName) {
      this.form.fpainter = artistName;
    },
    handleImages(files) {
      this.files = files;
      let filesList = {};
      this.updateFilesName();
      this.files.forEach((i) => {
        filesList[this.getKeyFiles(i)] = null;
        if (this.getKeyFiles(i) in this.filesList)
          filesList[this.getKeyFiles(i)] = this.filesList[this.getKeyFiles(i)];
      });
      this.filesList = filesList;
      this.isFilesEmpty = false;
    },
    phoneFormatted(val) {
      const valMass = val.split("");
      return (
        valMass[0] +
        valMass[1] +
        "&nbsp;(" +
        valMass[2] +
        valMass[3] +
        valMass[4] +
        ")&nbsp;<b>" +
        valMass[5] +
        valMass[6] +
        valMass[7] +
        "-" +
        valMass[8] +
        valMass[9] +
        "-" +
        valMass[10] +
        valMass[11] +
        "</b>"
      );
    },
    async handleSubmit() {
      if ((await this.$validate()) === false || !this.files.length) {
        this.isFilesEmpty = !this.files.length;
        return;
      }
      this.sendForm();
    },
    updateFilesName() {
      let filesList = Object.keys(this.filesList);
      this.files.forEach((item) => {
        if (filesList.indexOf(this.getKeyFiles(item)) === -1)
          this.uploadFiles(item);
      });
    },
    uploadFiles(uploadedFiles) {
      const formData = new FormData();
      formData.append("uploadedFiles", uploadedFiles);
      this.filesList[this.getKeyFiles(uploadedFiles)] = null;
      axios
        .post(this.uri + "/ajax/upload.php", formData, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.data.status === "success") {
            if (this.getKeyFiles(uploadedFiles) in this.filesList)
              this.filesList[this.getKeyFiles(uploadedFiles)] =
                response.data.file_link;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getKeyFiles(files) {
      return window.btoa(unescape(encodeURIComponent(files.name + files.size)));
    },
    toggleActionType(value, checked) {
      const newActionType = [...this.form.actionType];
      if (checked === 1) {
        if (!newActionType.includes(value)) {
          newActionType.push(value);
        }
      } else {
        const index = newActionType.indexOf(value);
        if (index !== -1) {
          newActionType.splice(index, 1);
        }
      }
      this.form.actionType = newActionType;
    },
    sendForm() {
      const $this = this;
      const formData = new FormData();

      let filesList = Object.keys(this.filesList);
      this.form.files = [];
      this.files.forEach((item) => {
        if (filesList.indexOf(this.getKeyFiles(item)) !== -1) {
          this.form.files.push(this.filesList[this.getKeyFiles(item)]);
        }
      });

      Object.keys(this.form).forEach((item) => {
        if (item === "files") {
          this.form[item].forEach((i) => {
            formData.append("files[]", i);
          });
        } else if (item === "actionType") {
          this.form[item].forEach((i) => {
            formData.append("actionType[]", i);
          });
        } else {
          if (item === "ftextarea") {
            const actionTypeMap = {
              auction: "Выставить на аукцион",
              sell: "Продать вне аукциона",
              buyout: "Нужен выкуп",
            };

            const actionTypeText = this.form.actionType
              .map((type) => actionTypeMap[type])
              .filter(Boolean)
              .join(" | ");

            const currentMessage = `
            ${this.form.fprice ? "Желаемая стоимость: " + this.form.fprice : ""}
            ${this.form.ftechnique ? "Техника: " + this.form.ftechnique : ""}
            ${this.form.fsize ? "Размеры: " + this.form.fsize : ""}
            ${this.form.expertise ? "Экспертиза: Да" : "Экспертиза: Нет"}
            ${
              actionTypeText
                ? "Что вы хотите сделать с работой: " + actionTypeText
                : ""
            }
            ${this.form.ftextarea ? "Комментарий: " + this.form.ftextarea : ""}
          `;
            formData.append("ftextarea", currentMessage.trim());
          } else {
            formData.append(item, this.form[item]);
          }
        }
      });

      axios
        .post(this.uri + "/services/form/?type=sell", formData)
        .then((response) => {
          if (response.status === 200 || response.status === 400) {
            /* global ym */
            if (typeof ym !== "undefined") {
              if ($this.form.fpainter.toLowerCase() === "другое") {
                ym(80148601, "reachGoal", "other_author_submitted");
              } else {
                ym(80148601, "reachGoal", "good_painting_submitted");
              }
            }

            $this.isSent = true;
            $this.form.fname = "";
            $this.form.femail = "";
            $this.form.ftel = "";
            $this.form.fpainter = "";
            $this.form.fsize = "";
            $this.form.fprice = "";
            $this.form.ftextarea = "";
            $this.form.actionType = [];
            $this.form.ftechnique = "";
            $this.form.expertise = "";
            $this.validation.reset();
            $this.files = [];

            window.dataLayer.push({
              event: "event-to-ga",
              eventCategory: "Lot_offer",
              eventAction: "submit",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    showArtistModal() {
      this.$modal.show("artist-modal");
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "src/styles/helpers/variables";

.offer-page__breadcrumbs {
  margin-bottom: 20px;
}

.offer-page__title {
  margin-bottom: 30px;
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
  color: #333333;

  @media #{$xs} {
    font-size: 22px;
    line-height: 120%;
  }
}

.offer-page__lead {
  margin-bottom: 20px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  color: #333333;
}

.offer-page__form-title {
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #000000;
}

.offer-page__form-list {
  display: grid;
  gap: 10px;
  padding: 0;
  margin: 0;
  list-style: none;
}

.offer-page__note {
  margin: 20px 0 30px;
  color: $color-alt;
  text-align: center;
}

.offer-page__contacts {
  display: flex;
  align-items: center;
  margin-bottom: 30px;

  @media #{$sm} {
    flex-wrap: wrap;
  }
}

.offer-page__list {
  list-style: none;
  padding: 0;
  margin: 0;
  counter-reset: works;

  > li {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;
    counter-increment: works;

    div {
      padding-top: 5px;
    }

    p {
      margin-bottom: 20px;
    }

    ul {
      padding-left: 0;
      list-style: none;

      li {
        margin-bottom: 5px;

        &:before {
          content: "– ";
        }
      }
    }

    &::before {
      content: counter(works);
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      margin-right: 20px;
      background: $main-brand-color;
      border: 2px solid $white;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.16);
      border-radius: 2px;
      font-weight: bold;
      font-size: 15px;
      line-height: 21px;
      text-align: center;
      color: $white;
    }
  }
}

.offer-page__contacts-item {
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 25px;
  text-align: left;

  a {
    color: currentColor;
    transition: $base-transition;

    &:hover {
      color: $link-hover-color;
    }
  }

  &::before {
    position: absolute;
    left: 0;
    top: 50%;
    display: block;
    transform: translateY(-50%);
  }

  &--email {
    margin-right: 70px;
  }

  &--phone::before {
    content: url("data:image/svg+xml,%3Csvg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15.5801 12.8426L12.3417 10.6829C11.9307 10.411 11.3798 10.5005 11.076 10.8885L10.1327 12.1013C10.0114 12.2612 9.79107 12.3076 9.61569 12.2101L9.43625 12.1112C8.8414 11.787 8.10126 11.3833 6.61001 9.89155C5.11876 8.39977 4.71429 7.65906 4.39006 7.06531L4.29167 6.88587C4.1929 6.71052 4.23839 6.48921 4.39831 6.36701L5.61038 5.42396C5.99819 5.1201 6.08777 4.56937 5.81622 4.15827L3.65654 0.919815C3.37824 0.501189 2.81988 0.37552 2.38904 0.634513L1.03484 1.44799C0.609337 1.69814 0.297165 2.10326 0.163778 2.57847C-0.323868 4.35527 0.0429835 7.42175 4.56019 11.9395C8.15353 15.5326 10.8286 16.4988 12.6673 16.4988C13.0904 16.5006 13.5119 16.4456 13.9204 16.3351C14.3957 16.2019 14.8009 15.8897 15.0509 15.4641L15.8652 14.1107C16.1246 13.6797 15.999 13.121 15.5801 12.8426Z' fill='%237B071A'/%3E%3C/svg%3E%0A");
  }

  &--email::before {
    content: url("data:image/svg+xml,%3Csvg width='17' height='13' viewBox='0 0 17 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0)'%3E%3Cpath d='M16.3583 1.67871L11.5059 6.49993L16.3583 11.3211C16.446 11.1378 16.4993 10.9351 16.4993 10.7187V2.28118C16.4993 2.06471 16.446 1.86205 16.3583 1.67871Z' fill='%237B071A'/%3E%3Cpath d='M15.0927 0.875H1.9052C1.68873 0.875 1.48608 0.928219 1.30273 1.01594L7.5047 7.18666C8.05308 7.73503 8.94483 7.73503 9.4932 7.18666L15.6952 1.01594C15.5118 0.928219 15.3092 0.875 15.0927 0.875Z' fill='%237B071A'/%3E%3Cpath d='M0.640938 1.67871C0.553219 1.86205 0.5 2.06471 0.5 2.28118V10.7187C0.5 10.9351 0.553219 11.1378 0.640938 11.3211L5.49341 6.49993L0.640938 1.67871Z' fill='%237B071A'/%3E%3Cpath d='M10.8427 7.16309L10.156 7.84974C9.24233 8.76346 7.75555 8.76346 6.84183 7.84974L6.1552 7.16309L1.30273 11.9843C1.48608 12.072 1.68873 12.1252 1.9052 12.1252H15.0927C15.3092 12.1252 15.5118 12.072 15.6952 11.9843L10.8427 7.16309Z' fill='%237B071A'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0'%3E%3Crect width='16' height='13' fill='white' transform='translate(0.5)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
    top: 60%;
  }
}

.sidebar-detail__phones {
  display: block;

  a {
    display: inline-block;
    padding: 5px 14px 5px 0;

    &:first-of-type {
      border-right: 0.5px solid rgba($main-brand-color, 0.8);
      margin-right: 14px;
    }
  }
}

.offer-page__form {
  .btn {
    width: 100%;
  }
}

.offer-page__form-wrap {
  display: grid;
  grid-template-columns: 1fr 1.4fr;
  grid-gap: 10px;
  align-items: flex-start;
  margin-bottom: 10px;

  @media #{$sm} {
    grid-template-columns: 1fr 1fr;
  }

  @media #{$xs} {
    grid-template-columns: 1fr;
    grid-gap: 20px;
    margin-bottom: 30px;
  }
}

.offer-page__form-group {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 15px;

  @media #{$xs} {
    grid-gap: 20px;
  }
}

.offer-page__form-error {
  display: block;
  width: 100%;
  margin-top: 5px;
  font-style: normal;
  font-weight: 300;
  color: $main-brand-color;
}

.offer-page__attention {
  display: flex;
  align-items: flex-start;

  &::before {
    content: "!";
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    margin-right: 20px;
    margin-top: 20px;
    background: $main-brand-color;
    border: 2px solid $white;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.16);
    border-radius: 2px;
    font-weight: bold;
    font-size: 15px;
    line-height: 21px;
    text-align: center;
    color: $white;
  }

  div {
    padding-top: 20px;
    border-top: 0.5px solid rgba(#b3b3b3, 0.8);
  }

  p {
    margin-bottom: 20px;
  }
}

.advantages-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 181px;
  padding: 8px 20px 14px;
  background: #ffffff;
  border: 1px solid #f3f3f3;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);

  @media #{$sm} {
    flex-direction: row;
    gap: 20px;
    min-height: auto;
  }

  @media #{$xs} {
    min-height: 150px;
    border-radius: 12px;
    padding: 20px 33px;
  }

  &:first-child {
    border-radius: 12px 0 0 12px;

    @media #{$sm} {
      border-radius: 12px 12px 0 0;
    }

    @media #{$xs} {
      border-radius: 12px;
    }
  }

  &:last-child {
    border-radius: 0 12px 12px 0;

    @media #{$sm} {
      border-radius: 0 0 12px 12px;
    }

    @media #{$xs} {
      border-radius: 12px;
    }
  }
}

.advantages-card__img {
  display: block;
  height: 50px;
  margin-bottom: 8px;

  @media #{$xs} {
    height: auto;
    width: 60px;
    margin: 0;
  }
}

.advantages-card__inner {
  text-align: center;
}

.advantages-card__title {
  margin-bottom: 6px;
  font-weight: 700;
  font-size: 16px;
  line-height: 140%;
  text-align: center;
  color: #333333;

  @media #{$sm} {
    text-align: left;
  }

  @media #{$xs} {
    font-size: 16px;
    line-height: 140%;

    br {
      display: none;
    }
  }
}

.advantages-card__text {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  text-align: center;
  color: #828282;

  @media #{$sm} {
    text-align: left;
  }

  @media #{$xs} {
    font-size: 12px;
    line-height: 140%;
  }
}

.offer-page__line {
  height: 1px;
  margin: 0 0 30px;
  border: 0;
  background: #eaeaea;
}
</style>
<style lang="scss">
@import "src/styles/helpers/variables";

.offer-page__form-list {
  display: grid;
  gap: 10px;
  padding: 0;
  margin: 0;
  list-style: none;

  .form-checkbox__text,
  .form-radio__text {
    padding-left: 26px;
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    color: #6f6f6f;

    &::before {
      top: 1px;
      background: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V3Z' stroke='%236F6F6F' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
      background-position: center;
      background-size: contain;
      width: 16px;
      height: 16px;
    }

    &::after {
      top: 2px;
    }
  }
}

.form-uploader {
  min-width: 0;
  margin-bottom: 20px;

  @media #{$xs} {
    width: 100%;
  }

  .container {
    background: $white;
    border: 2px dashed #e0e0e0;
    box-sizing: border-box;
    border-radius: 2px;

    @media #{$xs} {
      width: calc(100% - 4px);
      padding: 30px 10px;
    }

    .mainMessage {
      font-size: 13px;
      line-height: 18px;
      text-align: center;
      color: #707070;

      &::before {
        content: url("data:image/svg+xml,%3Csvg width='35' height='30' viewBox='0 0 35 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M32.2656 18.3188V26.4634C32.2656 27.1095 31.6523 27.6353 30.8984 27.6353H4.10156C3.3477 27.6353 2.73438 27.1095 2.73438 26.4634V18.3188H0V26.4634C0 28.4019 1.83996 29.979 4.10156 29.979H30.8984C33.16 29.979 35 28.4019 35 26.4634V18.3188H32.2656Z' fill='%23707070'/%3E%3Cpath d='M17.4999 0.0209961L9.00391 7.30326L10.9374 8.96053L16.1327 4.5074V22.772H18.8671V4.5074L24.0624 8.96053L25.9959 7.30326L17.4999 0.0209961Z' fill='%23707070'/%3E%3C/svg%3E%0A");
        display: block;
        width: 35px;
        height: 30px;
        margin: 0 auto 10px;
      }
    }
  }

  .beforeUpload .icon {
    display: none;
  }

  .imgsPreview .imageHolder .delete {
    background-color: $main-brand-color;
  }

  .imgsPreview {
    .imageHolder {
      .plus {
        line-height: 25px;
      }
    }
  }
}

.offer-page__artist-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 11px 16px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 2px;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: #6f6f6f;

  @media #{$xs} {
    padding: 20px 15px 19px;
  }

  &::after {
    content: "";
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='16' height='16' transform='translate(0 16) rotate(-90)' fill='white' fill-opacity='0.01'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.44982 12.8558C5.23493 12.6543 5.22405 12.3168 5.4255 12.1019L9.08353 8.2L5.4255 4.29813C5.22405 4.0832 5.23493 3.7457 5.44982 3.54421C5.66471 3.34282 6.00222 3.3537 6.20367 3.56853L10.2037 7.83523C10.396 8.04038 10.396 8.35961 10.2037 8.56477L6.20367 12.8314C6.00222 13.0463 5.66471 13.0572 5.44982 12.8558Z' fill='%236F6F6F'/%3E%3C/svg%3E%0A");
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: calc(100% - 32px);
  }
}

.offer-page__advantages {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 0 0 30px;
  margin: 0 0 30px;
  list-style: none;
  border-bottom: 1px solid #eaeaea;

  @media #{$sm} {
    grid-template-columns: 1fr;
  }

  @media #{$xs} {
    display: block;
    margin: 0 -15px 30px;
  }

  .hooper {
    height: auto;
  }

  .hooper-slide {
    display: flex;
    padding: 15px;
  }

  .hooper-pagination {
    position: static;
    transform: none;
    padding: 0;

    .hooper-indicators {
      width: 100%;
      justify-content: center;
    }

    .hooper-indicator {
      width: 8px;
      height: 8px;
      margin: 0 5px;
      background: #828282;
      border-radius: 50%;

      &.is-active {
        background: #7b071a;
      }
    }
  }
}
</style>
